export type ChartGridSharpCharts2Id = 'OFF' | 'MED' | 'DASHED' | 'HIGH';

export interface ChartGridOption {
  title: string;
  sharpCharts2Id: ChartGridSharpCharts2Id;
  isDark: boolean;
};

export const CHART_GRID_OPTION_OFF: ChartGridOption = {
  title: 'Off',
  sharpCharts2Id: 'OFF',
  isDark: false
};

export const CHART_GRID_OPTION_NORMAL: ChartGridOption = {
  title: 'Normal',
  sharpCharts2Id: 'MED',
  isDark: false
};

export const CHART_GRID_OPTION_DASHED: ChartGridOption = {
  title: 'Dashed',
  sharpCharts2Id: 'DASHED',
  isDark: false
};

export const CHART_GRID_OPTION_DENSE: ChartGridOption = {
  title: 'Dense',
  sharpCharts2Id: 'HIGH',
  isDark: false
};

export const CHART_GRID_OPTION_NORMAL_DARK: ChartGridOption = {
  title: 'Normal - Dark',
  sharpCharts2Id: 'MED',
  isDark: true
};

export const CHART_GRID_OPTION_DASHED_DARK: ChartGridOption = {
  title: 'Dashed - Dark',
  sharpCharts2Id: 'DASHED',
  isDark: true
};

export const CHART_GRID_OPTION_DENSE_DARK: ChartGridOption = {
  title: 'Dense - Dark',
  sharpCharts2Id: 'HIGH',
  isDark: true
};

export const DEFAULT_CHART_GRID_OPTION: ChartGridOption = CHART_GRID_OPTION_NORMAL;

export const CHART_GRID_OPTIONS_ARRAY: ChartGridOption[] = [
  CHART_GRID_OPTION_OFF,
  CHART_GRID_OPTION_NORMAL,
  CHART_GRID_OPTION_DASHED,
  CHART_GRID_OPTION_DENSE,
  CHART_GRID_OPTION_NORMAL_DARK,
  CHART_GRID_OPTION_DASHED_DARK,
  CHART_GRID_OPTION_DENSE_DARK
];

export function getChartGridObjFromChartGridTitle(chartGridTitle: string): ChartGridOption {
  return CHART_GRID_OPTIONS_ARRAY.find(option => option.title === chartGridTitle) ?? DEFAULT_CHART_GRID_OPTION;
}
